import { useContext, useEffect, useState, useRef } from "react";
import {
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Select,
  Dropdown,
  Menu,
  Form,
  message,
  InputNumber,
} from "antd";
import {
  UnorderedListOutlined, PlusOutlined,
  MinusOutlined, LinkOutlined, PlusCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined
} from "@ant-design/icons";
import { } from "@fortawesome/react-fontawesome";
import { } from "@fortawesome/free-regular-svg-icons";
import Input from "antd/es/input/Input";
import { HiOutlineDocumentCurrencyDollar } from "react-icons/hi2";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { MdPlaylistAddCheck } from "react-icons/md";
import { FormSelect } from "../../Components/FormSelect";
// import { SettingOutlined } from '@ant-design/icons';
import type { CollapseProps } from "antd";
import { Collapse } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FormInput } from "../../Components/FormInputs";
import DynamicFormCase from "../../Components/DynamicFieldRenderer/DynamicFieldRenderer";
//import form from "antd/es/form";
//import Form from "antd";

import "./Employeetabs.css";
import TextArea from "antd/es/input/TextArea";
import { getEmpGeneralInfo, visibilityOfAllowanceTab, visibilityOfITDeclarationTab } from "../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../Axios/Axios";
import { useAuthStore } from "../../AuthStore/AuthStore";
import Declarations from "./Declarations";
import Submission from "./Submission";
import {
  GetSectionComponentData,
  GetDocumentTypeData,
 
} from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";
import AllowanceTab from "./AllowanceTab";
import { useLocation } from "react-router-dom";

// const { Option } = Select;
const menu = (
  <Menu>
    <Menu.Item key="1">
      <a href="#">Edit</a>
    </Menu.Item>
    <Menu.Item key="2">
      <a href="#">Delete</a>
    </Menu.Item>
    <Menu.Item key="3">
      <a href="#">View Details</a>
    </Menu.Item>
  </Menu>
);

type ExpandIconPosition = "start" | "end";

const pdfUrl = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";

const { TabPane } = Tabs;
const { Panel } = Collapse;

interface IOptions {
  label?: string;
  value?: number | string;
  code?: string;
}

interface IFormData {
  sectionComponent?: IOptions | any;
  documentType?: IOptions | any;
  amount?: IOptions | any;
  documents?: IOptions | any;
}

const EmployeeTabs = () => {
 const location = useLocation();
  const state = location.state || {};
  const authStore = useAuthStore();

  const userId = authStore.userId;
  const currentFinancialYearId = authStore.currentFinancialYearId;


  const [expandIconPosition] = useState<ExpandIconPosition>("end");
  const [activeTabKeys, setActiveKeys] = useState<string>(state?.activeTab || "1");

 
  const [employeeName, setEmployeeName] = useState<any>("");
  const [regimTypeName, setRegimTypeName] = useState<any>("");//added by dnyaneshwar on 05-Jan-2026 
  // const [email, setEmail] = useState<any>("");
  // const [empCode, setEmpCode] = useState<any>("");
  // const [pan, setPan] = useState<any>("");
  // const [mobileNo, setMobileNo] = useState<any>("");
  const [description, setDescription] = useState<any>();
  // const [taxRegime, setTaxRegime] = useState<any>();
  // const [activeTab, setActiveTab] = useState("general");
  const [form] = Form.useForm();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [sectionComponent, setSectionComponent] = useState<any>([]);
  const [sectionsComponentOptions, setSectionsComponentOptions] = useState([]);
  const [formData, setFormData] = useState<IFormData>({});
  const [formErrors, setFormErrors] = useState<IFormData>({});
  const [formOptions, setFormOptions] = useState<IFormData>({});
  const [isAllowanceVisible, setIsAllowanceVisible] = useState<any>(false);
  const [isITDeclarationVisible, setIsITDeclaratoinVisible] = useState<any>(false);
  const [initialStateUserId, setInitialStateUserId] = useState<string | null>(state.userId);
  //const [viewMaskDetail, setViewMaskDetail] = useState<any>(false);
  const [visibleFields, setVisibleFields] = useState({
    employeeCode: false,
    pan: false,
    mobileNo: false,
  });  
  const [originalData, setOriginalData] = useState({
    employeeCode: '',
    pan: '',
    mobileNo: '',
  });

  const [isLock, setIsLock] = useState<any>(false);

  //  useEffect(() => {
  //   // Only set state userId on initial load
  //   if (state.userId && !initialStateUserId) {
  //    // setInitialStateUserId(state.userId);
  //     setActiveKeys("2"); // Navigate to Declaration tab directly
  //   }
  // }, [state.userId]);

  // const finalUserId = initialStateUserId || userId;

  //getGeneralInfo
  useEffect(
    () => {
      const getInfo = async () => {
      //  console.log('inside emolye general Info UserID=>', userId)
        const response = await API.post(getEmpGeneralInfo, {
          UserId: userId ? userId : 0,
          FyId: currentFinancialYearId,
        });

       // console.log('General Info response==>', response.data.data)
        if (response.data.data) {
          const data = response.data.data[0]
          form.setFieldsValue(data);
          setEmployeeName(data?.name);
          setRegimTypeName(data?.taxRegime);//added by dnyaneshwar on 05-Jan-2026 
          setOriginalData({
            employeeCode: data?.employeeCode || '',
            pan: data?.pan || '',
            mobileNo: data?.mobileNo || '',
          });
          form.setFieldsValue({
            employeeCode: maskValue(data?.employeeCode, false),
            pan: maskValue(data?.pan, false),
            mobileNo: maskValue(data?.mobileNo, false),
          });
          console.log('data?.description',data)
          setDescription(data?.description);
          const descriptionWithLink = data?.description.replace(
                                          `PageRedirectionLink`, 
                                          `<a href=${data?.urls} target="_blank">${data.linkName}</a>`
                                        );
          setDescription(descriptionWithLink);
          setIsLock(data?.isLock);

         // console.log('data==>', data)
         // setEmployeeName(data?.name);
          // setEmail(data?.emailId);
          // setEmpCode(data?.employeeCode);
          // setPan(data?.pan);
          // setMobileNo(data?.mobileNo);  
          // setTaxRegime(data?.taxRegime);

        }
      }

      getInfo()
  }, [userId, currentFinancialYearId])


  const handleToggle = (field: 'employeeCode' | 'pan' | 'mobileNo') => {
    const newVisible = !visibleFields[field];
    setVisibleFields(prev => ({ ...prev, [field]: newVisible }));

    form.setFieldsValue({
      [field]: maskValue(originalData[field], newVisible),
    });
  };

  const maskValue = (value: string, visible: boolean) => {
    if (!value) return '';
    return visible ? value : value.slice(0, 3) + 'X'.repeat(value.length - 3);
  };

  const handleCollapseChange = (keys: string | string[]) => {
   // setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  const expandIcon = (panelProps: any) => {
    const isActive = activeTabKeys.includes(panelProps.key);
    return isActive ? <MinusOutlined /> : <PlusOutlined />;
  };

  const onChange = (key: string | string[]) => {
    console.log(key);
  };

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Cycle 1 (dd/mm/yyyy)",
      children: (
        <>
          <div className="accordCont">
            <p>
              80D - (LTA) : <span className="pending">Pending</span>
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
              >
                <Button
                  className="popOption"
                  type="text"
                  onClick={(e: any) => e.preventDefault()}
                >
                  <BsThreeDotsVertical />
                </Button>
              </Dropdown>
            </p>
            <p>Travel Tickets</p>
            <a href="#">Document 1</a>
            <p className="mt-1">Submission Date : 14-10-2024</p>
          </div>
          <div className="accordCont">
            <p>
              80D - (LTA) : <span className="pending">Pending</span>
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
              >
                <Button
                  className="popOption"
                  type="text"
                  onClick={(e: any) => e.preventDefault()}
                >
                  <BsThreeDotsVertical />
                </Button>
              </Dropdown>
            </p>
            <p>Travel Tickets</p>
            <a href="#">Document 1</a>
            <p className="mt-1">Submission Date : 14-10-2024</p>
          </div>
          <div className="accordCont">
            <p>
              80D - (LTA) : <span className="pending">Pending</span>
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
              >
                <Button
                  className="popOption"
                  type="text"
                  onClick={(e: any) => e.preventDefault()}
                >
                  <BsThreeDotsVertical />
                </Button>
              </Dropdown>
            </p>
            <p>Travel Tickets</p>
            <a href="#">Document 1</a>
            <p className="mt-1">Submission Date : 14-10-2024</p>
          </div>
        </>

      ),

    },
    {
      key: "2",
      label: "Cycle 2 (dd/mm/yyyy)",
      children: (
        <div className="accordCont">
          <p>
            80D - (LTA) : <span className="reject">Reject</span>{" "}
            <BsThreeDotsVertical className="popOption" />
          </p>
          <p>Travel Tickets</p>
          <a href="#">Document 2</a>
          <p className="mt-1">Submission Date : 14-10-2024</p>
        </div>
      ),

    },
    {
      key: "3",
      label: "Cycle 3 (dd/mm/yyyy)",
      children: (
        <div className="accordCont">
          <p>
            80D - (LTA) : <span className="aprroved">Aprroved</span>{" "}
            <BsThreeDotsVertical size={"1.2em"} className="popOption" />
          </p>
          <p>Travel Tickets</p>
          <a href="#">Document 3</a>
          <p className="mt-1">Submission Date : 14-10-2024</p>
        </div>
      ),

    },
  ];

  function handleFieldChange(name: any, value: any) {
    throw new Error("Function not implemented.");
  }

  //#region Submission
  // useEffect(() => {
  //   GetSectionComponent();
  //   //GetDocumentType();
  // }, []);

  const GetSectionComponent = async () => {
    try {

      showLoader();
      let {data:{data}} = await API.post(GetSectionComponentData, {
        FinancialYearId: currentFinancialYearId
      });

      if (data) {
        // //setSectionsComponentOptions(response.data.data.sectionComponentList);
        const formattedData = data.sectionComponentList.map((item: { name: string | null; Id: number  | null; }) => ({
          label: item?.name,
          value: item?.Id,
        }));
        // setSectionsComponentOptions(formattedData);
        setFormOptions((prev) => {
        
          return {
            ...prev,
            sectionComponent: formattedData || [],
          };
        });
      }
    }
    catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform GetSectionComponent`);
    } finally {
      hideLoader();
    }
  };
  const formOnChange = (e: any, type: any) => {

    switch (type) {
      case "sectionComponent":
        setFormData((prev) => {
          return {
            ...prev,
            sectionComponent: e,
          };
        })
        break;

        break;

      default:
        break;
    }
  }
 
  //#endregion

  //console.log(formOptions);

    useEffect(()=>{

      //for allowance
      const getVisibilityForAllowanceTab = async()=>{

        let response = await API.post(visibilityOfAllowanceTab,{
          UserId : userId,
          FinancialYearId : currentFinancialYearId
        })

       // console.log('allowance visibility response===>',response?.data?.data[0].isAllowanceVisible)
        if(response?.data?.data[0].isAllowanceVisible){
          let value = response?.data?.data[0].isAllowanceVisible;
         // console.log('visible value===>',value)
          setIsAllowanceVisible(value);
        }
      }

       const getVisibilityForITDeclarationTab = async()=>{

        let DeclarationTabresponse = await API.post(visibilityOfITDeclarationTab,{
          UserId : userId,
          FinancialYearId : currentFinancialYearId
        })
      //  console.log('response is ',DeclarationTabresponse)
      // console.log('allowance visibility response===>',DeclarationTabresponse?.data?.data?.[0]?.isITDeclarationTabVisible)
        if(DeclarationTabresponse?.data?.data?.[0]?.isITDeclarationTabVisible){
          let declarationvalue = DeclarationTabresponse?.data?.data?.[0]?.isITDeclarationTabVisible;
         // console.log('visible value===>',value)
          setIsITDeclaratoinVisible(declarationvalue);
        }
      }

      getVisibilityForITDeclarationTab();
      getVisibilityForAllowanceTab();

    },[userId,currentFinancialYearId])

  return (
    <div>
      
      <Card className="tabsEmpl">

        <Tabs type="card" tabPosition="top" activeKey={activeTabKeys} onChange={(key) => {
            console.log('tab changed click ',key)
           setInitialStateUserId(null);
           setActiveKeys(key) 
        }}>
          {/* Tab 1 */}
          { state.userId == null &&
          <TabPane
            tab={
              <span>
                <UnorderedListOutlined style={{ fontSize: "0.9em" }} /> General
              </span>
            }
            key="1"
            className="general_content"
          >
            {/* <Card className="generalcard"> */}
              <Form form={form} layout="vertical">
                <Row gutter={[16, 8]} className="justify-content-between">
                  <Col span={8} xs={24} sm={24} md={24} lg={24}>
                    <div className="mt-2">
                      <h4>Welcome {employeeName}!</h4>
                    </div>
                  </Col>
                 
                </Row>
                <Row gutter={[16, 8]} >
                  <Col xs={24} sm={6} md={6} lg={5}>
                    <FormInput
                      name={"emailId"}
                      value={form.getFieldValue("emailId")}
                      label="Email ID:"
                      disabled={true}

                    // type = "text"
                    />
                    
                  </Col>
                  <Col xs={24} sm={6} md={6} lg={5}>
                    <FormInput
                      label="Employee Code:"
                      name={"employeeCode"}
                      //value={form.getFieldValue("employeeCode")}
                     // value={maskValue(form.getFieldValue("employeeCode"), viewMaskDetail.employeeCode)}
                      disabled={true}
                      suffix={
                              visibleFields.employeeCode ? (
                                <EyeInvisibleOutlined onClick={() => handleToggle('employeeCode')} />
                              ) : (
                                <EyeOutlined onClick={() => handleToggle('employeeCode')} />
                              )
                            }
                    />
                    
                  </Col>
                  <Col xs={24} sm={6} md={6} lg={5}>
                    <FormInput
                      label="PAN No:"
                      name={"pan"}
                      //value={form.getFieldValue("pan")}
                     // value={maskValue(form.getFieldValue("pan"), viewMaskDetail.pan)}
                      disabled={true}
                      suffix={
                              visibleFields.pan ? (
                                <EyeInvisibleOutlined onClick={() => handleToggle('pan')} />
                              ) : (
                                <EyeOutlined onClick={() => handleToggle('pan')} />
                              )
                            }
                    />
                    
                  </Col>
                  <Col xs={24} sm={6} md={6} lg={5}>
                    <FormInput
                      label="Mobile No:"
                      name={"mobileNo"}
                     // value={form.getFieldValue("mobileNo")}
                    // value={maskValue(form.getFieldValue("mobileNo"), viewMaskDetail.mobileNo)}
                      disabled={true}
                      suffix={
                              visibleFields.mobileNo ? (
                                <EyeInvisibleOutlined onClick={() => handleToggle('mobileNo')} />
                              ) : (
                                <EyeOutlined onClick={() => handleToggle('mobileNo')} />
                              )
                            }
                    />
               
                  </Col>
                   <Col span={6} xs={24} offset-sm={0} offset-xs={10} offset-md={0} offset-lg={10} sm={6} md={6} lg={4}>
                    {/* <div className="jutify-content-end"> */}
                      <FormInput
                        name={"taxRegime"}
                        label={"Tax Regime:"}
                        value={form.getFieldValue("taxRegime")}
                        disabled={true}
                      // onchange = {(e:any)=>console.log(e)}
                      // style={{ height: "32px" }}

                      />


                  </Col>
                </Row>
               
              </Form>
            {/* </Card> */}
            <div className="mt-3" dangerouslySetInnerHTML={{ __html: description }} />
            {/* {desciption} */}
           
          </TabPane>
          }
          {/* Tab 2 */}
          { state.userId != null || (isITDeclarationVisible &&
            isITDeclarationVisible)
          ?
          <TabPane
            tab={
              <span>
                <MdPlaylistAddCheck size={"1.5em"} /> IT Declaration
              </span>
            }
            key="2"
          >
            {/* <p>Content for Tab 2</p> */}
            <Declarations stateUserId={initialStateUserId || null} IsLocked={initialStateUserId !=null ? true : isLock}></Declarations>
          </TabPane>
          :
          <></>
          }

          {/* Tab 3 - Responsive Three-Column Boxes */}
          { state.userId == null &&
          <TabPane
            tab={
              <span>
                <HiOutlineDocumentCurrencyDollar size={"1.2em"} /> Investment
                Submission
              </span>
            }
            key="3"
          >
            <Submission form={form} IsLocked={isLock}  regimTypeName={regimTypeName}></Submission>

            {/* <Row
              gutter={[16, 8]}
              className="tabsBtns d-flex justify-content-end"
            >
              <Col xs={24} sm={6} md={12} lg={5}>
                <FormSelect
                  name={"sectionComponent"}
                  label={"Section/Component"}
                  rules={[{ "required": "true" }]}
                  placeholder={"Section/Component"}
                  //widthSize={field.widthSize}
                  //options={formOptions}
                  options={formOptions?.sectionComponent || []}
                  // options={field.fieldOptions.map(opt => ({
                  //   value: String(opt.value),  // Ensure values are strings
                  //   label: opt.label
                  // }))}


                  mode={undefined}
                  onChange={(value: any) => {
                    console.log('onchange value=>', value)
                    formOnChange(value, "sectionComponent")
                  }
                  }
                  filterOption={true}
                // onSearch={(e: any) => handleSearch(e, field.name)}
                // onClick={() => handleClick(field.name)} // Trigger onClick
                />
              </Col>
              <Col xs={24} sm={6} md={12} lg={5}>
                <Button className="btn-viewsub uplBtn w-100" type="default">
                  <LinkOutlined /> Upload Investment Proof
                </Button>
              </Col>
              <Col xs={24} sm={6} md={12} lg={5}>
                <FormSelect></FormSelect>
              </Col>
              <Col className="tabsBtns" xs={24} sm={6} md={12} lg={5}>
                <Input
                  type="text"
                  placeholder="Amount"
                  style={{ height: "32px" }}
                ></Input></Col>
              <Col xs={24} sm={6} md={12} lg={2}>
                <Button type="default" className="createBtn">
                  <PlusCircleOutlined /> Add{" "}
                </Button>
              </Col>
            </Row> 
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={6} md={12} lg={6}>
                <Card bordered={true} className=" cardby" id="custom-scroll">
                  <div className="accordianDetail">
                    <Collapse
                      defaultActiveKey={["1"]}
                      // onChange={onChange}
                      expandIconPosition={expandIconPosition}
                      items={items}
                      expandIcon={expandIcon}
                      activeKey={activeKeys}
                      onChange={handleCollapseChange}
                    />
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={6} md={12} lg={6}>
                <Card bordered={true} className=" cardby">
                  <Form layout="vertical" className="tabform">
                    <Row gutter={16} className="p-0">
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          label="Amount"
                          name="InputNumber"
                          rules={[{ required: true, message: "Please input!" }]}
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          label="Name of Lender"
                          name="Input"
                          rules={[{ required: true, message: "Please input!" }]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          label="Bank Address of Lender"
                          name="Input"
                          rules={[{ required: true, message: "Please input!" }]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          label="TextArea"
                          name="TextArea"
                          rules={[{ required: true, message: "Please input!" }]}
                        >
                          <TextArea rows={2} />
                        </Form.Item>

                      </Col>
                    </Row>
                  </Form>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={24} lg={12}>
                <Card bordered={true} className="p-0 pdfView">
                  <div style={{ maxWidth: "900px", margin: "auto" }}>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        overflow: "auto",
                      }}
                      className="pdfBox"
                    >
                      <Worker
                        workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.worker.min.js`}
                      >
                        <Viewer fileUrl={pdfUrl} />
                      </Worker>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
            <div className="savBtns d-flex justify-content-end mt-3">
              <Button className="btn-saveDraft me-3" type="default">
                Save as Draft
              </Button>
              <Button className="btn-viewsub" type="default">
                View & Submit
              </Button>
            </div>*/}
          </TabPane>
          }

          { (state.userId == null && (isAllowanceVisible && 
            isAllowanceVisible ))?
            <TabPane
              tab={
                <span>
                  <MdOutlineLibraryBooks size={"1.2em"} /> Allowances
                </span>
              }
              key="4"
            >
            <AllowanceTab IsLocked={isLock}></AllowanceTab>
            </TabPane>
          :
          <></>
          }
          {/* <TabPane
              tab={
                <span>
                  <MdOutlineLibraryBooks size={"1.2em"} /> Allowances
                </span>
              }
              key="4"
            >
            <AllowanceTab></AllowanceTab>
          </TabPane> */}
          
        </Tabs>
      </Card>
    </div>
  );
};

export default EmployeeTabs;
